import React from 'react';
import LotsEditor from './LotsEditor';
import SaveButton from '../SaveButton';
import { LotsDraft } from '../../hooks/useLotsDraft';

interface LotsCardProps {
  draft: LotsDraft;
  kitQuantity?: number;
  boxQuantity?: number;
  saving: boolean;
  /** Hold Save while something else is in flight. */
  disabled?: boolean;
  onSave: () => void;
  /** Blue ring plus a note in the head, used while the footer asks to confirm shipping. */
  highlight?: boolean;
  hint?: React.ReactNode;
  cardRef?: React.Ref<HTMLElement>;
}

// The "Lots" card shared by the order and Thunderbird pop-ups: Undo / Save actions in the
// head, the kit and box lot tables in the body.
const LotsCard: React.FC<LotsCardProps> = ({
  draft,
  kitQuantity,
  boxQuantity,
  saving,
  disabled = false,
  onSave,
  highlight = false,
  hint,
  cardRef,
}) => (
  <section
    ref={cardRef}
    className={`op-card${highlight ? ' is-highlight' : ''}`}
  >
    <div className="op-card-head">
      <h5>Lots</h5>
      {hint ? <small>{hint}</small> : null}
      <div className="op-card-actions">
        {draft.unsavedCount > 0 ? (
          <button
            type="button"
            className="btn-app btn-app--outline btn-app--sm"
            onClick={draft.discard}
            disabled={saving}
            title="Discard all unsaved lot changes"
          >
            Undo changes
          </button>
        ) : null}
        <SaveButton
          dirty={draft.unsavedCount > 0}
          saving={saving}
          disabled={disabled}
          label="Save lots"
          badge={`${draft.unsavedCount} unsaved`}
          onClick={onSave}
        />
      </div>
    </div>
    <div className="op-card-body">
      <LotsEditor
        key={draft.editorKey}
        kitLots={draft.kitLots}
        boxLots={draft.boxLots}
        onKitLotsChange={draft.setKitLots}
        onBoxLotsChange={draft.setBoxLots}
        kitQuantity={kitQuantity}
        boxQuantity={boxQuantity}
      />
    </div>
  </section>
);

export default LotsCard;
